import React from 'react'
import '../../styles/button.css'
import { useSelector } from 'react-redux';
const Button = ({title,onClick}) => {
  const { isDark } = useSelector((state) => state.useReducer);
  return <button onClick={onClick} id='button' style={{ backgroundColor: `${isDark ? "#070F2B" : "#fff"}`, borderColor: "#3F51B5", color: "#3F51B5" }}>{title}</button>
}

export default Button
